<template>
  <div>
    <el-dialog
      :title="title + '公共代码'"
      visible
      :close-on-click-modal="false"
      width="900px"
      :before-close="close"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item
            prop="name"
            label="名称"
          >
            <el-input
              v-model.trim="form.name"
              placeholder="请输入名称"
              clearable
            />
          </el-form-item>
          <el-form-item
            prop="type"
            label="代码类型"
          >
            <el-select
              v-model.trim="form.type"
              placeholder="请选择代码类型"
              clearable
            >
              <el-option
                v-for="item in typeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            prop="description"
            label="描述"
          >
            <el-input
              v-model.trim="form.description"
              type="textarea"
              :rows="3"
              placeholder="请输入描述"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="close">
          取 消
        </el-button>
        <el-button
          type="primary"
          @click="add"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isCopy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        name: '',
        type: '',
        description: ''
      },
      rules: {
        name: { required: true, message: '请输入名称', trigger: 'blur' },
        type: { required: true, message: '请选择代码分类', trigger: 'change' },
        description: { required: true, message: '请输入描述', trigger: 'blur' }
      },
      typeList: ['js', 'css']
    }
  },
  computed: {
    title() {
      return this.isEdit ? '修改' : '新增'
    },
    funName() {
      let name = 'save'
      if (this.isCopy) {
        name = 'clone'
      } else if (this.isEdit) {
        name = 'update'
      }
      return name
    }
  },
  created() {
    if (this.isCopy || this.isEdit) {
      this.form = this.value
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    add() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$message.error('请录入所有必填项！')
        }
        this.$api.public.save(this.form).then((data) => {
          this.$message.success(this.title + '成功！')
          data.codeData = data.codeData || ''
          this.$emit('addSuccess', data)
        })
      })
    }
  }
}
</script>
